// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"94440a9e","147":"a2ece08a","171":"6e5d4b71","374":"b684dd4d","507":"6dee292d","520":"921263c0","574":"373f35dc","685":"59806029","743":"a22ff95b","780":"239f86b1","875":"14e1b2d0","968":"33a3d363"}[chunkId] + ".chunk.js";
};